import { render, staticRenderFns } from "./AppCardRouterButton.vue?vue&type=template&id=402fc1d7&scoped=true&"
import script from "./AppCardRouterButton.vue?vue&type=script&lang=js&"
export * from "./AppCardRouterButton.vue?vue&type=script&lang=js&"
import style0 from "./AppCardRouterButton.vue?vue&type=style&index=0&id=402fc1d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402fc1d7",
  null
  
)

export default component.exports